module.exports = {
	"_args": [
		[
			"cssom@https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "cssom@>=0.3.0 <0.4.0",
	"_id": "cssom@0.3.1",
	"_inCache": true,
	"_location": "/cssom",
	"_phantomChildren": {},
	"_requested": {
		"name": "cssom",
		"raw": "cssom@https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
		"rawSpec": "https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
	"_shasum": "c9e37ef2490e64f6d1baa10fda852257082c25d3",
	"_shrinkwrap": null,
	"_spec": "cssom@https://registry.npmjs.org/cssom/-/cssom-0.3.1.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "me@elv1s.ru",
		"name": "Nikita Vasilyev"
	},
	"bugs": {
		"url": "https://github.com/nv/CSSOM/issues"
	},
	"dependencies": {},
	"description": "CSS Object Model implementation and CSS parser",
	"devDependencies": {
		"jake": "~0.7.3"
	},
	"files": [
		"lib/"
	],
	"homepage": "https://github.com/nv/CSSOM#readme",
	"keywords": [
		"CSS",
		"CSSOM",
		"parser",
		"styleSheet"
	],
	"license": "MIT",
	"main": "./lib/index.js",
	"name": "cssom",
	"optionalDependencies": {},
	"readme": "# CSSOM\n\nCSSOM.js is a CSS parser written in pure JavaScript. It also a partial implementation of [CSS Object Model](http://dev.w3.org/csswg/cssom/). \n\n    CSSOM.parse(\"body {color: black}\")\n    -> {\n      cssRules: [\n        {\n          selectorText: \"body\",\n          style: {\n            0: \"color\",\n            color: \"black\",\n            length: 1\n          }\n        }\n      ]\n    }\n\n\n## [Parser demo](http://nv.github.com/CSSOM/docs/parse.html)\n\nWorks well in Google Chrome 6+, Safari 5+, Firefox 3.6+, Opera 10.63+.\nDoesn't work in IE < 9 because of unsupported getters/setters.\n\nTo use CSSOM.js in the browser you might want to build a one-file version that exposes CSSOM global variable:\n\n    ➤ git clone https://github.com/NV/CSSOM.git\n    ➤ cd CSSOM\n    ➤ npm install -d\n    ➤ ./node_modules/.bin/jake\n    build/CSSOM.js is done\n\nTo use it with Node.js or any other CommonJS loader:\n\n    ➤ npm install cssom\n\n## Don’t use it if...\n\nYou parse CSS to mungle, minify or reformat the following code:\n\n```css\ndiv {\n  background: gray;\n  background: linear-gradient(to bottom, white 0%, black 100%);\n}\n```\n\nThis pattern is often used to give browsers that don’t understand linear gradients a fallback solution (e.g. gray color in the example).\nIn CSSOM, `background: gray` [gets overwritten](http://nv.github.io/CSSOM/docs/parse.html#css=div%20%7B%0A%20%20%20%20%20%20background%3A%20gray%3B%0A%20%20%20%20background%3A%20linear-gradient(to%20bottom%2C%20white%200%25%2C%20black%20100%25)%3B%0A%7D).\nThe last same-name property always overwrites all the previous ones.\n\n\nIf you do CSS mungling, minification, image inlining, and such, CSSOM.js is no good for you, considere using one of the following:\n\n  * [postcss](https://github.com/postcss/postcss)\n  * [reworkcss/css](https://github.com/reworkcss/css)\n  * [csso](https://github.com/css/csso)\n  * [mensch](https://github.com/brettstimmerman/mensch)\n\n\n## [Specs](http://nv.github.com/CSSOM/spec/)\n\nTo run specs locally:\n\n    ➤ git submodule init\n    ➤ git submodule update\n\n\n## [Who uses CSSOM.js](https://github.com/NV/CSSOM/wiki/Who-uses-CSSOM.js)\n",
	"readmeFilename": "README.mdown",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/nv/CSSOM.git"
	},
	"scripts": {
		"prepublish": "jake lib/index.js"
	},
	"version": "0.3.1"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/cssom/package.json
 ** module id = ./node_modules/cssom/package.json
 ** module chunks = 0
 **/